import React from "react";
import styles from "./Loader.module.css";


export const Loader = () => {
  return (
    <div className={styles.loaderOverlay}>
      <div className={styles.loaderContainer}>
        <div  className={styles.spinner}/>
        {/* <p className={styles.message}>{message}</p> */}
      </div>
    </div>
  );
};